module.exports = __webpack_public_path__ + "tables/media/dark-dashboard.acb11e5d.svg";